import { Injectable } from '@angular/core';
import { ResourcesService } from '../resources.service';
import { Booking } from '../../model/booking';
import { Observable } from 'rxjs/Observable';
import { BookingCalculation } from '../../model/booking-calculation';

@Injectable()
export class BookingService {

  constructor(
    private _resources: ResourcesService
  ) { }

  getCalculatedPrice(booking: Booking, supplierId: number | string): Observable<BookingCalculation> {
    return this._resources.post(
      'booking/AgentCalculatePricing',
      {
        reservation: booking
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/api/resources/booking/booking.service.ts